// Booking loop (setter spec §05.17, §06.4, §10.5, §15.7): outcome capture, «resultado pendiente» list and the
// per-project reminder / advisor-notification settings. Schemas in api-appointment-loop.ts. Shared by every module.
import * as L from './api-appointment-loop.js';
import { AppointmentDetailSchema } from './api-calendar.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

export const appointmentLoopRoutes = {
  recordAppointmentOutcome: route({
    method: 'POST', path: '/workspaces/:workspaceId/appointments/:appointmentId/outcome', summary: 'Registrar el resultado de la cita (Realizada, No show, Cancelada o Reprogramada)', tag: 'appointments',
    minRole: 'advisor', module: null, params: W({ appointmentId: IdParam }), body: L.RecordAppointmentOutcomeSchema, response: AppointmentDetailSchema,
  }),
  listPendingOutcomes: route({
    method: 'GET', path: '/workspaces/:workspaceId/appointment-outcomes/pending', summary: 'Citas pasadas sin resultado informado', tag: 'appointments',
    minRole: 'advisor', module: null, params: Ws, query: L.PendingOutcomeQuerySchema, response: items(L.PendingOutcomeItemSchema),
  }),
  getAppointmentLoopConfig: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/appointment-settings', summary: 'Recordatorios, avisos al asesor y resultado de citas del proyecto', tag: 'projects',
    minRole: 'advisor', module: null, params: W({ projectId: IdParam }), response: L.AppointmentLoopConfigResponseSchema,
  }),
  putAppointmentLoopConfig: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/appointment-settings', summary: 'Guardar recordatorios, avisos al asesor y resultado de citas del proyecto', tag: 'projects',
    minRole: 'admin', module: null, params: W({ projectId: IdParam }), body: L.AppointmentLoopConfigSchema, response: L.AppointmentLoopConfigResponseSchema,
  }),
};
